// You can write more code here

import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import PaywallPanel from '@/game/prefabs/Login/PaywallPanel';

/* START OF COMPILED CODE */

export default class Paywall extends Phaser.Scene {
  constructor() {
    super('Paywall');

    /* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // paywallPanel
    const paywallPanel = new PaywallPanel(this, 0, 0);
    this.add.existing(paywallPanel);

    this.paywallPanel = paywallPanel;

    this.events.emit('scene-awake');
  }

  private paywallPanel!: PaywallPanel;

  /* START-USER-CODE */

  static hasCheckedPaywall: boolean = false;

  create() {
    this.editorCreate();
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.USER_LOADED,
      this.handleCheckUserAuthStatus,
      this,
    );
  }

  async handleCheckUserAuthStatus() {
    await this.paywallPanel.checkPaywall();
    Paywall.hasCheckedPaywall = true;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
